// extracted by mini-css-extract-plugin
module.exports = {"mainSplitView":"_2KZ-w","topLayout":"_392od"};